import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../site/auth";
import { useSeo } from "../../site/ui";
import { RecipeCard, recipeApi } from "./LaonaRecipe";

/* 레시피 갤러리 — 비회원도 본다. 레시피는 따로 쓰지 않는다 — 회원이 내 프로젝트(수동)를
   [레시피 공개하기]로 공개하면 여기 나온다 (백엔드 app/laona_manual.py recipes_router) */
export default function LaonaRecipes() {
  const { member } = useAuth();
  const [state, setState] = useState({ status: "loading", items: [] });

  useSeo({
    title: "레시피 갤러리 — LaonaBot",
    description: "라오나봇으로 만든 시제품 레시피와 완성 예시. 검증된 모듈 조합 · 배선도 · 동작 모습을 볼 수 있습니다.",
    path: "/laonabot/recipes",
  });

  useEffect(() => {
    let alive = true;
    recipeApi("")
      .then((d) => alive && setState({ status: "ready", items: d.items }))
      .catch(() => alive && setState({ status: "error", items: [] }));
    return () => { alive = false; };
  }, []);

  return (
    <section className="lb-section lb-section--top">
      <div className="lb-wrap">
        <header className="lb-head lb-head--row">
          <div>
            <p className="lb-kicker">RECIPES</p>
            <h1>레시피 갤러리</h1>
            <p className="lb-lead">
              회원들이 직접 설계하고 배선까지 마친 시제품을 공개한 레시피입니다.
              마음에 드는 레시피를 내 프로젝트로 가져와 그대로, 또는 내 아이디어에 맞게 바꿔 만들 수 있습니다.
            </p>
          </div>
          <div className="lb-head__tools">
            {member && <Link to="/laonabot/projects" className="lb-btn">내 프로젝트 공개하기</Link>}
            <Link to={member ? "/laonabot/start" : "/laonabot/signup"} className="lb-btn lb-btn--primary">
              프로젝트 시작하기
            </Link>
          </div>
        </header>

        {state.status === "loading" && <p className="lb-empty">레시피를 불러오는 중입니다…</p>}
        {state.status === "error" && <p className="lb-empty">레시피를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.</p>}
        {state.status === "ready" && !state.items.length && (
          <div className="lb-empty lb-empty--box">
            <b>아직 공개된 레시피가 없습니다</b>
            <p>내 프로젝트에서 배선까지 마친 프로젝트를 [레시피 공개하기]로 첫 레시피를 올려 보세요.</p>
          </div>
        )}
        {state.items.length > 0 && (
          <div className="lb-cards">
            {state.items.map((r) => <RecipeCard key={r.id} recipe={r} />)}
          </div>
        )}
      </div>
    </section>
  );
}
